import React from "react";
import { inputType } from "../../../Domain/Constants/InputType";
import { validateTextInput } from "../../../Domain/Helpers/InputValidationHelper";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";

function TenantUpdatePage(props) {
    const inputs = [
        {
            inputType: inputType.TEXT,
            labelText: "External ID",
            required: true,
            inputId: "external_id",
            validationFunction: (value) => validateTextInput(value, "External ID", true, 50)
        },
        {
            inputType: inputType.TEXT,
            labelText: "Name",
            required: true,
            inputId: "name",
            validationFunction: (value) => validateTextInput(value, "Name", true, 50)
        }
    ];

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"tenant/update"}
            pageTitle={"Update Tenant"}
            isUpdate={true}
            getEndpoint={"tenant/read"}
            entityName={"Tenant"} />
    )
}

export default TenantUpdatePage;